module.exports = __webpack_public_path__ + "img/材料力学8_2.ae85f567.jpg";